import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import {
  Box,
  Divider,
  Typography,
  List,
  ListItem,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ActivityFeedListItemProps {
  readonly date: string;
  readonly time: string;
  readonly notification: string;
}

const ActivityFeedListItem = ({
  date,
  time,
  notification,
}: ActivityFeedListItemProps): JSX.Element => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Box sx={{ pr: 2 }}>
          <NotificationsIcon
            sx={{
              color: theme.palette.primary.main,
              height: '18px',
              width: '18px',
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '150px',
          }}>
          <Typography variant="body2">{date}</Typography>
          <Typography variant="body2">{time}</Typography>
        </Box>
      </Box>
      {/* notification  */}
      <Box>
        <Typography variant="body1">{notification}</Typography>
      </Box>
    </Box>
  );
};

interface ActivityFeedProps {
  readonly dates: readonly string[];
  readonly times: readonly string[];
  readonly notifications: readonly string[];
}

export const ActivityFeed = ({
  dates,
  times,
  notifications,
}: ActivityFeedProps): JSX.Element => {
  const { t } = useTranslation(['home']);
  const theme = useTheme();
  return (
    <List sx={{ p: 1 }}>
      <ListItem>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            //fontSize: '18px',
            pt: 1,
            pb: 1,
          }}>
          <Box sx={{ pr: 1 }}>
            <NotificationsNoneIcon
              sx={{
                height: '45px',
                width: '45px',
                color: theme.palette.primary.main,
              }}
            />
          </Box>
          <Typography variant="body1">
            {t('home:activityFeed.header')}
          </Typography>
        </Box>
      </ListItem>
      {notifications.map((props, idx) => (
        <div key={notifications[idx]}>
          <Divider />
          <ListItem>
            <ActivityFeedListItem
              notification={notifications[idx]}
              date={dates[idx]}
              time={times[idx]}
            />
          </ListItem>
        </div>
      ))}
    </List>
  );
};
